<script lang="ts">
  import { cn } from "$lib/utils/cn";
  import type { Snippet } from "svelte";

  interface Props {
    for?: string;
    class?: string;
    children: Snippet;
  }

  let {
    for: htmlFor,
    class: className,
    children,
  }: Props = $props();
</script>

<label
  for={htmlFor}
  class={cn(
    "block text-xs font-medium text-text-secondary mb-1.5",
    className
  )}
>
  {@render children()}
</label>
